import type { ReactNode } from 'react';

interface SeoJsonLdProps {
  data: Record<string, unknown>;
}

export default function SeoJsonLd({ data }: SeoJsonLdProps): ReactNode {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}